import { SwiperSlide } from 'swiper/react';
import React from 'react';

import {
    Carousel,
    CarouselArrowNavigation,
    CarouselWrapper
} from '$partials/base/carousel';

import {
    ArticleListingItem,
    EventListingItem
} from '$partials/items';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').SearchCarouselBlock}
 */
const SearchCarousel = ({
    ctaLabel = '',
    ctaLink = null,
    desktopSlidesPerView = 2.5,
    items = null,
    title = ''
}) => {
    return (
        <section className='flex flex-wrap -mx-4 md:-mx-8 pt-24 pb-8 md:pb-24'>
            <Carousel
                swiperConfig={{
                    a11y: { enabled: true },
                    slidesPerView: 1.2,
                    slidesOffsetBefore: 8,
                    slidesOffsetAfter: 8,
                    breakpoints: {
                        992: {
                            slidesPerView: 2.35,
                            slidesOffsetBefore: 16,
                            slidesOffsetAfter: 16
                        },
                        1440: {
                            slidesPerView: desktopSlidesPerView,
                            slidesOffsetBefore: 16,
                            slidesOffsetAfter: 16
                        }
                    },
                    spaceBetween: 8,
                    grabCursor: false,
                }}>
                <div className='w-full px-8 md:px-16 flex items-center gap-8 md:gap-16 mb-16'>
                    <h2 className='type-style-sans-h2-med'>
                        {title}
                    </h2>

                    {ctaLink && (items.length > Math.ceil(desktopSlidesPerView)) && (
                        <button
                            className='button-outcome ml-auto'
                            dangerouslySetInnerHTML={{ __html: ctaLabel }}
                            onClick={() => ctaLink()}
                            type='button' />
                    )}

                    {items?.length > 0 && (items.length > Math.ceil(desktopSlidesPerView)) && (
                        <div className={`hidden sm:block${ctaLink ? '' : ' ml-auto'}`}>
                            <CarouselArrowNavigation />
                        </div>
                    )}
                </div>

                <CarouselWrapper>
                    {items?.map(item => {
                        if (!item?.node) { return null; }

                        let Component;
                        switch (item.node.__typename) {
                            case 'ArticleDetailPage':
                                Component = ArticleListingItem;
                                break;

                            case 'EventDetailPage':
                                Component = EventListingItem;
                                break;
                        }

                        return (
                            <SwiperSlide
                                aria-roledescription='slide'
                                className='select-none cursor-pointer flex flex-wrap mt-4'
                                key={item?.node?.id}
                                role='group'>
                                <Component {...item?.node} />
                            </SwiperSlide>
                        );
                    }).filter(Boolean)}
                </CarouselWrapper>
            </Carousel>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default SearchCarousel;
